export const API_BASE_URL = 'https://api.zotero.org';
export const API_KEY = 'wJP6BSWTorMeph7NhXsOQIHl';
export const GROUP_ID = '2468861';
